/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";
import { useTranslation } from "react-i18next";

import { HeaderLogo } from "components/AppHeader/components";

import "./HamburgerMenu.scss";

interface IHamburgerMenuProps {
  children?: React.ReactNode;
}

export const HamburgerMenu = ({ children }: IHamburgerMenuProps) => {
  const { t } = useTranslation();

  return (
    <nav className="HamburgerMenu" role="navigation">
      <div id="HamburgerMenu__Toggle">
        <input type="checkbox" aria-label={t("COMMON__MENU", "Menu")} />

        <span></span>
        <span></span>
        <span></span>

        <div className="HamburgerMenu__Content">
          <HeaderLogo className="HamburgerMenu" />
          <div className="HamburgerMenu__Items">{children}</div>
        </div>
      </div>
    </nav>
  );
};
